<div id="documento-aditivo-container-header" class="documento-aditivo-container nova-pagina">
  <app-header-documento-final-proposta
    [entidadeProposta]="entidadeProposta"
    [razaoSocialEntidade]="razaoSocialEntidade"
    [codigoProposta]="codigoProposta"
    [vigenciaProposta]="vigenciaProposta"
    [operadoraVM]="operadoraVM"
    [dadosOperadoraCabecalho]="dadosOperadoraCabecalho"></app-header-documento-final-proposta>
</div>

<div id="form-beneficiario" class="form-enxuto">
  <div *ngFor="let formulario of listaBeneficiariosFormulario; let i = index" style="margin-bottom: 2rem">
    <div *ngIf="formulario" class="ficha-beneficiario d-flex">
      <div class="ficha-beneficiario container-fluid d-flex">
        <div class="barra-lateral">
          <span class="texto-vertical">
            {{ i === 0 ? 'BENEFICIÁRIO TITULAR' : 'DEPENDENTE' + ' ' + i }}
          </span>
        </div>
        <div class="conteudo-formulario flex-grow-1">
          <form [formGroup]="formulario" class="form-layout row">
            <!-- Formulário do Titular -->
            <section class="row container-fluid" *ngIf="i === 0">
              <!-- Linha 1 -->

              <div class="form-group col-md-4">
                <label class="label-upper">Nome beneficiário - titular</label>
                <input class="form-control line-style" readonly formControlName="name" />
              </div>
              <div class="form-group col-md-2 col-md-6-tablet">
                <label class="label-upper">Data de nascimento</label>
                <input class="form-control line-style" readonly formControlName="birthDate" />
              </div>
              <div class="form-group col-md-2 col-md-6-tablet">
                <label class="label-upper">CPF</label>
                <input class="form-control line-style" readonly formControlName="cpf" />
              </div>
              <div class="form-group col-md-2 col-md-6-tablet">
                <label class="label-upper">RG</label>
                <input class="form-control line-style" readonly formControlName="rg" />
              </div>

              <!-- Linha 2 -->

              <div class="form-group col-md-2 col-md-4-tablet">
                <label class="label-upper">Data de Expedição</label>
                <input class="form-control line-style" readonly formControlName="shipmentDate" />
              </div>
              <div class="form-group col-md-2 col-md-4-tablet">
                <label class="label-upper">Orgão Expeditor</label>
                <input class="form-control line-style" readonly formControlName="idIssuingBody" />
              </div>
              <div class="form-group col-md-2 col-md-4-tablet">
                <label class="label-upper">Estado Civil</label>
                <input class="form-control line-style" readonly formControlName="civilStatus" />
              </div>
              <div class="form-group col-md-1 col-md-2-tablet">
                <label class="label-upper">Sexo</label>
                <input class="form-control line-style" readonly formControlName="sex" />
              </div>
              <div class="form-group col-md- col-md-10-tablet">
                <label class="label-upper">CNS</label>
                <input class="form-control line-style" readonly [value]="formulario.get('cns')?.value" />
              </div>

              <!-- Linha 3 -->
              <div class="form-group col-md-2 col-md-6-tablet">
                <label class="label-upper">Data de Admissão</label>
                <input class="form-control line-style" readonly formControlName="dataAdmissao" />
              </div>
              <div class="form-group col-md-2 col-md-6-tablet">
                <label class="label-upper">PIS</label>
                <input class="form-control line-style" readonly formControlName="pis" />
              </div>
              <div class="form-group col-md-2 col-md-4-tablet" *ngIf="!isOdonto()">
                <label class="label-upper">Local do Atendimento</label>
                <input class="form-control line-style" readonly formControlName="localAtendimento" />
              </div>
              <div class="form-group col-md-4 col-md-8-tablet">
                <label class="label-upper">Nome da Mãe</label>
                <input class="form-control line-style" readonly formControlName="mothersName" />
              </div>

              <!-- Linha 4 -->
              <div class="form-group col-md-3 col-md-12-tablet">
                <label class="label-upper">Endereço Completo</label>
                <input class="form-control line-style" readonly formControlName="adress" />
              </div>
              <div class="form-group col-md-1 col-md-2-tablet">
                <label class="label-upper">Número</label>
                <input class="form-control line-style" readonly formControlName="number" />
              </div>
              <div class="form-group col-md-2 col-md-10-tablet">
                <label class="label-upper">Complemento</label>
                <input class="form-control line-style" readonly formControlName="adressComplement" />
              </div>

              <!-- Linha 5 -->
              <div class="form-group col-md-2 col-md-6-tablet">
                <label class="label-upper">Bairro</label>
                <input class="form-control line-style" readonly formControlName="neighborhood" />
              </div>
              <div class="form-group col-md-2 col-md-6-tablet">
                <label class="label-upper">Cidade</label>
                <input class="form-control line-style" readonly formControlName="city" />
              </div>
              <div class="form-group col-md-1 col-md-2-tablet">
                <label class="label-upper">UF</label>
                <input class="form-control line-style" readonly formControlName="state" />
              </div>
              <div class="form-group col-md-1 col-md-4-tablet">
                <label class="label-upper">CEP</label>
                <input class="form-control line-style" readonly [value]="formulario.get('cep')?.value" />
              </div>
              <div class="form-group col-md-2 col-md-6-tablet">
                <label class="label-upper">Operadora Anterior</label>
                <input class="form-control line-style" readonly formControlName="previousOperator" />
              </div>

              <!-- Linha 6 -->
              <div class="form-group col-md-2 col-md-4-tablet">
                <label class="label-upper">Tempo de Permanência</label>
                <input class="form-control line-style" readonly formControlName="dwellTime" />
              </div>
              <div class="form-group col-md-2 col-md-4-tablet">
                <label class="label-upper">Celular</label>
                <input class="form-control line-style" readonly formControlName="mobilePhone" />
              </div>
              <div class="form-group col-md-2 col-md-4-tablet">
                <label class="label-upper">Telefone Residencial</label>
                <input class="form-control line-style" readonly formControlName="homePhone" />
              </div>
              <div class="form-group col-md-2 col-md-4-tablet">
                <label class="label-upper">Telefone Comercial</label>
                <input class="form-control line-style" readonly formControlName="businessPhone" />
              </div>
              <div class="form-group col-md-3 col-md-8-tablet">
                <label class="label-upper">E-mail</label>
                <input class="form-control line-style" readonly formControlName="email" />
              </div>
            </section>

            <!-- Formulário do Dependente -->
            <section class="row container-fluid" *ngIf="i > 0">
              <!-- <div>
                <h3>DEPENDENTE(S) - {{ +i }}</h3>
              </div>
              <br /> -->
              <!-- Linha 1  -->

              <div class="form-group col-md-3 col-md-12-tablet">
                <label class="label-upper">Nome completo</label>
                <input class="form-control line-style" readonly formControlName="name" />
              </div>
              <div class="form-group col-md-2 col-md-6-tablet">
                <label class="label-upper">Data de Nascimento</label>
                <input class="form-control line-style" readonly formControlName="birthDate" />
              </div>
              <div class="form-group col-md-2 col-md-6-tablet">
                <label class="label-upper">CNS</label>
                <input class="form-control line-style" readonly formControlName="cns" />
              </div>

              <!-- Linha 2  -->
              <div class="form-group col-md-1 col-md-4-tablet">
                <label class="label-upper">CPF</label>
                <input class="form-control line-style" readonly formControlName="cpf" />
              </div>
              <div class="form-group col-md-1 col-md-4-tablet">
                <label class="label-upper">RG</label>
                <input class="form-control line-style" readonly formControlName="rg" />
              </div>
              <div class="form-group col-md-1 col-md-4-tablet">
                <label class="label-upper">Data de Expedição</label>
                <input class="form-control line-style" readonly formControlName="shipmentDate" />
              </div>
              <div class="form-group col-md-1 col-md-4-tablet">
                <label class="label-upper">Orgão Expeditor</label>
                <input class="form-control line-style" readonly formControlName="idIssuingBody" />
              </div>
              <div class="form-group col-md-1 col-md-4-tablet">
                <label class="label-upper">Sexo</label>
                <input class="form-control line-style" readonly [value]="formulario.get('sex')?.value" />
              </div>
              <div class="form-group col-md-2 col-md-4-tablet">
                <label class="label-upper">Estado Civil</label>
                <input class="form-control line-style" readonly formControlName="civilStatus" />
              </div>

              <!-- Linha 3 -  -->
              <div *ngIf="!heMedSenior" class="form-group col-md-6">
                <label class="label-upper">Declaração de Nascido Vivo</label>
                <input class="form-control line-style" readonly formControlName="declaracaoNascidoVivo" />
              </div>
              <div class="form-group col-md-2 col-md-6-tablet" *ngIf="!isOdonto()">
                <label class="label-upper">Operadora Anterior</label>
                <input class="form-control line-style" readonly formControlName="previousOperator" />
              </div>
              <div *ngIf="!isOdonto()" class="form-group col-md-2 col-md-6-tablet">
                <label class="label-upper">Tempo de Permanência</label>
                <input class="form-control line-style" readonly formControlName="dwellTime" />
              </div>
              <div class="form-group col-md-2 col-md-6-tablet">
                <label class="label-upper">Grau de Parentesco</label>
                <input class="form-control line-style" readonly formControlName="branchCompanyContractKinship" />
              </div>

              <!-- Linha 4  -->

              <div class="form-group col-md-7 col-md-8-tablet">
                <label class="label-upper">Nome Completo da Mãe</label>
                <input class="form-control line-style" readonly formControlName="mothersName" />
              </div>

              <div class="form-group col-md-3 col-md-4-tablet">
                <label class="label-upper">Local de Atendimento</label>
                <input class="form-control line-style" readonly formControlName="localAtendimento" />
              </div>
            </section>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
